import axios, { AxiosResponse } from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const getTimezonesThunk = createAsyncThunk(
  'app/getTimezonesThunk',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const responseUserData: AxiosResponse<any> = await axios.get(`/global-options/timezones`)
      return responseUserData.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getSocialContentRestrictionsThunk = createAsyncThunk(
  'app/getSocialContentRestrictionsThunk',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const responseUserData: AxiosResponse<any> = await axios.get(
        `/global-options/social-content-restrictions`
      )
      return responseUserData.data.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getSocialMediaRestrictionsThunk = createAsyncThunk(
  'app/getSocialMediaRestrictionsThunk',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const responseUserData: AxiosResponse<any> = await axios.get(
        `/global-options/social-media-restrictions`
      )
      return responseUserData.data.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const Mock = {}
